<div class="responsive-card d-flex flex-column gap-4">
  <div class="d-flex flex-column gap-3">
    <span class="responsive-card-title" i18n>File Uploads</span>
    <span class="responsive-card-description" i18n
      >Attach all documentation required to support this submission. These will be stored against the member's
      record.</span
    >
  </div>
  <form class="d-flex flex-column gap-4" [formGroup]="formGroup">
    <div class="d-flex flex-column gap-1">
      <label for="files" class="form-input-label" i18n>File Upload</label>
      <app-file-upload-field
        formControlName="files"
        [control]="formGroup.controls.files"
        [inputName]="'files'"
        [controlId]="'files'"
        [multiple]="true"
        [accept]="['image/png', 'image/jpeg', 'application/pdf']"
        [submitAttempted]="formSubmitted"
        [showThumbnail]="true">
        <ng-container input-copy>
          <img height="24" src="assets/icons/grey/FileUpload.svg" alt="Upload File" i18n-alt />
          <app-file-uploader-text descriptionText=".png, .jpeg, or .pdf up to 3 MB" i18n-descriptionText />
        </ng-container>
      </app-file-upload-field>
    </div>
    <ng-container *ngIf="existingFiles?.length">
      <div class="d-flex flex-column gap-2">
        <app-file-list-item
          *ngFor="let file of existingFiles"
          [fileName]="file.attachment.fileName"
          [fileSizeInBytes]="file.attachment.fileSize"
          [showLabel]="false"
          [previewUrl]="file.attachment.links | attachmentLink"
          action="remove"
          (removeClicked)="removeFile.emit(file)" />
      </div>
    </ng-container>
  </form>
</div>
